import React from 'react';
import Icon from '../../../components/AppIcon';

const ConversationListItem = ({ conversation, isActive, onSelect }) => {
  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday?.setDate(yesterday?.getDate() - 1);

    if (date?.toDateString() === today?.toDateString()) {
      return date?.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    } else if (date?.toDateString() === yesterday?.toDateString()) {
      return 'Dün';
    } else {
      return date?.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }
  };

  const truncateMessage = (text, maxLength = 35) => {
    if (!text) return 'Henüz mesaj yok';
    return text?.length > maxLength ? text?.substring(0, maxLength) + '...' : text;
  };

  const handleClick = () => {
    // Ensure onSelect is called with the conversation object
    if (onSelect && conversation) {
      onSelect(conversation);
    }
  };

  return (
    <div
      onClick={handleClick}
      className={`flex items-center gap-4 px-4 py-3 cursor-pointer transition-all hover:bg-gray-50 border-b border-gray-100 ${
        isActive ? 'bg-blue-50' : 'bg-white'
      }`}
    >
      {/* Avatar */}
      <div className="relative flex-shrink-0">
        <div 
          className={`w-12 h-12 rounded-full overflow-hidden flex items-center justify-center ${
            conversation?.type === 'group' ? 'bg-blue-600' : 'bg-blue-600'
          }`}
        >
          {conversation?.avatar ? (
            <img
              src={conversation?.avatar}
              alt={conversation?.name}
              className="w-full h-full object-cover"
            />
          ) : (
            <span className="text-white font-semibold text-lg">
              {conversation?.name?.charAt(0)?.toUpperCase()}
            </span>
          )}
        </div>
        
        {/* Online Status Indicator */}
        {conversation?.isOnline && (
          <div className="absolute bottom-0 right-0 w-3.5 h-3.5 bg-blue-600 rounded-full border-2 border-white"></div>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-semibold text-[17px] truncate" style={{ color: '#111b21' }}>
            {conversation?.name || 'İsimsiz Kullanıcı'}
          </h3>
          
          <span 
            className={`text-xs ml-2 flex-shrink-0 ${
              conversation?.unreadCount > 0 ? 'text-blue-600' : 'text-gray-500'
            }`}
          >
            {formatTime(conversation?.lastMessageTime)}
          </span>
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-1.5 min-w-0 flex-1">
            {/* Message Status Icons */}
            {conversation?.lastMessageIsMine && (
              <Icon 
                name={conversation?.lastMessageRead ? 'CheckCheck' : 'Check'} 
                size={16} 
                color={conversation?.lastMessageRead ? '#53bdeb' : '#667781'}
              />
            )}
            
            {/* Typing Indicator */}
            {conversation?.isTyping ? (
              <span className="text-sm italic text-blue-600">
                yazıyor...
              </span>
            ) : (
              <p className="text-sm truncate" style={{ color: '#667781' }}>
                {truncateMessage(conversation?.lastMessage)}
              </p>
            )}
          </div>

          {/* Unread Count Badge */}
          {conversation?.unreadCount > 0 && (
            <div className="flex-shrink-0 min-w-[20px] h-5 px-1.5 rounded-full flex items-center justify-center ml-2 bg-blue-600">
              <span className="text-xs font-semibold text-white">
                {conversation?.unreadCount > 99 ? '99+' : conversation?.unreadCount}
              </span>
            </div>
          )}

          {/* Pinned Icon */}
          {conversation?.isPinned && (
            <Icon name="Pin" size={14} color="#8696a0" className="ml-1 flex-shrink-0" />
          )}

          {/* Muted Icon */}
          {conversation?.isMuted && (
            <Icon name="BellOff" size={14} color="#8696a0" className="ml-1 flex-shrink-0" />
          )}
        </div>
      </div>
    </div>
  );
};

export default ConversationListItem;